import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly BASE_URL: string;
  private API_VERSION = 'v1';
  constructor(private http: HttpClient) {
    this.BASE_URL = environment['apiUrls'].baseUrl;
  }
  // AI Assistant Apis
  getLangTime(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/assistants/predefined`
    );
  }

  getDashBoard(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/dashboard/config`
    );
  }

  getAssistantDetail(assistantId): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/assistants/${assistantId}`
    );
  }

  createAssistantBasicDetail(assistant): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/assistants`;
    const body = assistant;
    return this.http.post(url, body);
  }

  createBusinessDetail(assistantId, business): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/assistants/${assistantId}/business-details`;
    const body = business;
    return this.http.post(url, body);
  }

  validateCredential(assistantId, type, channelDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/assistants/${assistantId}/validate-${type}`;
    const body = channelDetail;
    return this.http.post(url, body);
  }

  getAllAiAssistant(pageNo, pageLimit, assistantName?) {
    if (assistantName) {
      return this.http.get(
        `${this.BASE_URL}/${this.API_VERSION}/assistants?page=${pageNo}&size=${pageLimit}&name=${assistantName}`
      );
    }
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/assistants?page=${pageNo}&size=${pageLimit}`
    );
  }

  getActiveAssistant() {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/assistants/active`
    );
  }

  getAgentAssistant() {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/agent/assistants`
    );
  }

  generateAgentSession(assistantId: any) {
    const url = `${this.BASE_URL}/${this.API_VERSION}/agent/session`;
    const body = { assistantId: assistantId };
    return this.http.put(url, body);
  }


  updateAssistantBasicDetail(assistantId, assistant): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/assistants/${assistantId}`;
    const body = assistant;
    return this.http.put(url, body);
  }

  updateAssistantBusinessDetail(assistantId, assistant): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/assistants/${assistantId}/business-details`;
    const body = assistant;
    return this.http.put(url, body);
  }

  updateAssistantChannelDetails(assistantId, channelInfo): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/assistants/${assistantId}/channel-details`;
    const body = channelInfo;
    return this.http.put(url, body);
  }

  activateAssistant(assistantId, status): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/assistants/${assistantId}/updateStatus?status=${status}`;
    const body = null;
    return this.http.put(url, body);
  }
  // Inbox API
  unreadEmailCount(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/email/inbox/count`
    );
  }

  getAllEmail(pageNo, pageLimit, requestType): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/email/inbox?page=${pageNo}&size=${pageLimit}&requestType=${requestType}`
    );
  }

  getMailThreads(pageNo, pageLimit, requestType, folder): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/email/threads?page=${pageNo}&size=${pageLimit}&requestType=${requestType}&folder=${folder}`
    );
  }

  getMessages(threadId): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/email/threads/${threadId}`
    );
  }

  actionEmail(activityId, status): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/email/inbox/update?activityId=${activityId}&status=${status}`;
    const body = null;
    return this.http.put(url, body);
  }
  // Campaign Apis
  getAllAccountFunnel(pageNo, pageLimit, funnelName?): Observable<any> {
    if (funnelName) {
      return this.http.get(
        `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels?page=${pageNo}&size=${pageLimit}&name=${funnelName}`
      );
    }
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels?page=${pageNo}&size=${pageLimit}`
    );
  }

  deleteAccountFunnel(accountFunnelId): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels/${accountFunnelId}/delete`;
    const body = null;
    return this.http.put(url, body);
  }

  deletePersona(accountFunnelId, personaId): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels/${accountFunnelId}/personas/${personaId}/delete`;
    const body = null;
    return this.http.put(url, body);
  }

  getCountryEmp(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/campaign/pre-requisites`
    );
  }

  createAccount(basicDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels`;
    const body = basicDetail;
    return this.http.post(url, body);
  }

  getAccountFunnel(accountFunnelId): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels/${accountFunnelId}`
    );
  }

  updateAccountBasicDetail(accountFunnelId, account): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels/${accountFunnelId}`;
    const body = account;
    return this.http.put(url, body);
  }

  getAllPersona(accountFunnelId): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels/${accountFunnelId}/personas`
    );
  }

  uploadAccount(accountFunnelId, fileDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels/${accountFunnelId}/upload-accounts`;
    const body = fileDetail;
    return this.http.post(url, body);
  }

  getAccountsByFunnelId(accountFunnelId, pageNo, pageLimit): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/accounts/getAccountsByFunnelId/${accountFunnelId}?page=${pageNo}&size=${pageLimit}`
    );
  }

  getLeadsByPersonaId(personaId, pageNo, pageLimit) {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/leads/getLeadsByPersonaId/${personaId}?page=${pageNo}&size=${pageLimit}`
    );
  }

  getQualifiedLeadsByPersonaId(personaId, pageNo, pageLimit) {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/leads/getLeadsByPersonaId/${personaId}?page=${pageNo}&size=${pageLimit}&isQualified=true`
    );
  }

  // Create persona
  createPersona(basicDetail, accountFunnelId): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels/${accountFunnelId}/personas`;
    const body = basicDetail;
    return this.http.post(url, body);
  }

  getPersona(accountFunnelId, personaId): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels/${accountFunnelId}/personas/${personaId}`
    );
  }

  updatePersona(personaDetail, accountFunnelId, personaId): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels/${accountFunnelId}/personas/${personaId}`;
    const body = personaDetail;
    return this.http.put(url, body);
  }

  uploadLead(accountFunnelId, personaId, fileDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels/${accountFunnelId}/personas/${personaId}/upload-leads`;
    const body = fileDetail;
    return this.http.post(url, body);
  }

  getCampaignAction(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/campaign/actions`
    );
  }

  getCampaignSequence(accountFunnelId, personaId): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels/${accountFunnelId}/personas/${personaId}/sequences`
    );
  }

  createCampaignSequence(accountFunnelId, personaId, data): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels/${accountFunnelId}/personas/${personaId}/sequences`;
    const body = data;
    return this.http.post(url, body);
  }

  updateCampaignSequence(accountFunnelId, personaId, data): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels/${accountFunnelId}/personas/${personaId}/sequences`;
    const body = data;
    return this.http.put(url, body);
  }

  launchCampaignActive(accountFunnelId): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels/${accountFunnelId}/launch`;
    const body = null;
    return this.http.post(url, body);
  }

  updateCampaignStatus(accountFunnelId, status): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/campaign/account-funnels/${accountFunnelId}/status`;
    const body = { 'status': status };
    return this.http.put(url, body);
  }

  getCampaignFormConfig(campaignId): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/campaign/${campaignId}/form-config`
    );
  }

  contentGetEmailTemplate(pageNo, pageLimit, name?): Observable<any> {
    if (name) {
      return this.http.get(
        `${this.BASE_URL}/${this.API_VERSION}/email/templates?page=${pageNo}&size=${pageLimit}&name=${name}`
      );
    }
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/email/templates?page=${pageNo}&size=${pageLimit}`
    );
  }

  getTemplateRequisites(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/email/templates/pre-requisites`
    );
  }

  createTemplate(templateDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/email/templates`;
    const body = templateDetail;
    return this.http.post(url, body);
  }
  updateTemplate(templateId, templateDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/email/templates/${templateId}`;
    const body = templateDetail;
    return this.http.put(url, body);
  }

  deleteTemplate(templateIdList): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/email/templates/delete`;
    const body = templateIdList;
    return this.http.put(url, body);
  }

  uploadEmailTemplateFile(templateId, files) {
    const url = `${this.BASE_URL}/${this.API_VERSION}/email/templates/${templateId}/upload/attachments`;
    const body = files;
    return this.http.post(url, body);
  }

  getUploadedAttachments(templateId): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/email/templates/${templateId}/attachments`
    );
  }

  downloadAttachments(templateId, attachmentId): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/email/templates/${templateId}/attachments/${attachmentId}/download`,
      { responseType: 'blob' }
    );
  }

  deleteAttachments(templateId, attachmentIdList): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/email/templates/${templateId}/attachments/delete`;
    const body = attachmentIdList;
    return this.http.put(url, body);
  }

  getProspectLeadList(
    pageNo,
    pageLimit,
    status,
    name?,
    personaId?
  ): Observable<any> {
    if (name) {
      return this.http.get(
        `${this.BASE_URL}/${this.API_VERSION}/leads?page=${pageNo}&size=${pageLimit}&name=${name}&status=${status}`
      );
    }
    if (personaId) {
      return this.http.get(
        `${this.BASE_URL}/${this.API_VERSION}/leads?page=${pageNo}&size=${pageLimit}&status=${status}&personaId=${personaId}`
      );
    }
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/leads?page=${pageNo}&size=${pageLimit}&status=${status}`
    );
  }

  getAllAccount(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/accounts/getAccounts`
    );
  }

  getLeadPrerequisites(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/leads/pre-requisites`
    );
  }

  updateProspectLead(leadId, leadDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/leads/${leadId}`;
    const body = leadDetail;
    return this.http.put(url, body);
  }

  createProspectLead(leadDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/leads`;
    const body = leadDetail;
    return this.http.post(url, body);
  }

  deleteProspectLead(leadIdList): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/leads/delete`;
    const body = leadIdList;
    return this.http.put(url, body);
  }


  getLeadActivity(leadId, pageNo, pageLimit): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/leads/${leadId}/activities?page=${pageNo}&size=${pageLimit}`
    );
  }

  getLeadEmailHistory(leadId, pageNo, pageLimit): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/leads/${leadId}/email-history?page=${pageNo}&size=${pageLimit}`
    );
  }

  uploadProspectLead(fileDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/leads/upload-leads`;
    const body = fileDetail;
    return this.http.post(url, body);
  }

  uploadLeadsToProspectList(listId, fileDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/leads/leadList/${listId}/upload-leads`;
    const body = fileDetail;
    return this.http.post(url, body);
  }

  addLeadList(listId, leadList): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/leads/leadList/${listId}/add`;
    const body = leadList;
    return this.http.post(url, body);
  }

  getDeliveredLists(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/leads/leadList/getDeliveredLists`
    );
  }

  addToDeliveredList(requestBody): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/leads/leadList/addToDeliveredList`;
    return this.http.post(url, requestBody);
  }

  getListPrerequisites(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/leads/leadList/pre-requisites`
    );
  }

  getProspectList(pageNo, pageLimit, name?, types?): Observable<any> {
    if (name) {
      return this.http.get(
        `${this.BASE_URL}/${this.API_VERSION}/leads/leadList?page=${pageNo}&size=${pageLimit}&name=${name}`
      );
    }
    if (types) {
      return this.http.get(
        `${this.BASE_URL}/${this.API_VERSION}/leads/leadList?page=${pageNo}&size=${pageLimit}&types=${types}`
      );
    }
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/leads/leadList?page=${pageNo}&size=${pageLimit}`
    );
  }

  updateProspectList(listId, listDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/leads/leadList/${listId}`;
    const body = listDetail;
    return this.http.put(url, body);
  }

  createProspectList(listDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/leads/leadList`;
    const body = listDetail;
    return this.http.post(url, body);
  }

  deleteProspectList(listIds): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/leads/leadList/delete`;
    const body = listIds;
    return this.http.put(url, body);
  }

  getLeadFormListId(pageNo, pageLimit, listId, isDelivered = null) {
    let url = `${this.BASE_URL}/${this.API_VERSION}/leads/leadList/${listId}/leads?page=${pageNo}&size=${pageLimit}`;
    if (isDelivered) {
      url += `&isDelivered=${isDelivered}`;
    }
    return this.http.get(url);
  }

  exportList(listId, isDelivered = null, status = null): Observable<HttpResponse<Blob>> {
    let url = `${this.BASE_URL}/${this.API_VERSION}/download/leadList/${listId}/leads`;
    const params: string[] = [];
    if (isDelivered) {
      params.push(`isDelivered=${isDelivered}`);
    }
    if (status) {
      params.push(`status=${status}`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    return this.http.get(url, { responseType: 'blob', observe: 'response' });
  }

  deleteLeadList(listId, leadIdRecord) {
    const url = `${this.BASE_URL}/${this.API_VERSION}/leads/leadList/${listId}/delete`;
    const body = leadIdRecord;
    return this.http.put(url, body);
  }

  // Account

  getAccountPrerequisites(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/accounts/pre-requisites`
    );
  }

  getAccountCount(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/accounts/typeCount`
    );
  }

  getAccountList(pageNo, pageLimit, type, name?, filterKey?, filterValue?): Observable<any> {
    if (name) {
      return this.http.get(
        `${this.BASE_URL}/${this.API_VERSION}/accounts?page=${pageNo}&size=${pageLimit}&type=${type}&name=${name}&filterKey=${filterKey}&filterValue=${filterValue}`
      );
    } else if (filterKey && filterValue) {
      return this.http.get(
        `${this.BASE_URL}/${this.API_VERSION}/accounts?page=${pageNo}&size=${pageLimit}&type=${type}&filterKey=${filterKey}&filterValue=${filterValue}`
      );
    }
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/accounts?page=${pageNo}&size=${pageLimit}&type=${type}`
    );
  }

  updateAccountList(accountId, accountDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/accounts/${accountId}`;
    const body = accountDetail;
    return this.http.put(url, body);
  }

  createAccountList(accountDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/accounts`;
    const body = accountDetail;
    return this.http.post(url, body);
  }

  deleteAccountList(listIds): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/accounts/delete`;
    const body = listIds;
    return this.http.put(url, body);
  }

  uploadAccountList(fileDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/accounts/upload-accounts`;
    const body = fileDetail;
    return this.http.post(url, body);
  }

  // User Management

  getRoles(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/role`
    );
  }

  createUser(userDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/users/createNewUser`;
    const body = userDetail;
    return this.http.post(url, body);
  }

  updateUser(userDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/users/updateUser`;
    const body = userDetail;
    return this.http.put(url, body);
  }

  deleteUser(userId): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/users/deleteUser`;
    const body = [userId];
    return this.http.put(url, body);
  }

  getAllUsers(pageNo, pageLimit, name?): Observable<any> {
    if (name) {
      return this.http.get(
        `${this.BASE_URL}/${this.API_VERSION}/users?page=${pageNo}&size=${pageLimit}&name=${name}`
      );
    }
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/users?page=${pageNo}&size=${pageLimit}`
    );
  }

  getUsers(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/users/getAllUsers`
    );
  }

  // Asset

  getAssetPrerequisites(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/asset/pre-requisites`
    );
  }
  createAsset(assetDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/asset/create`;
    const body = assetDetail;
    return this.http.post(url, body);
  }

  updateAsset(assetDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/asset/updateAsset`;
    const body = assetDetail;
    return this.http.put(url, body);
  }

  deleteAsset(assetId): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/asset/deleteAsset`;
    const body = assetId;
    return this.http.put(url, body);
  }

  getAllAssets(pageNo, pageLimit, name?): Observable<any> {
    if (name) {
      return this.http.get(
        `${this.BASE_URL}/${this.API_VERSION}/asset/getAssets?page=${pageNo}&size=${pageLimit}&name=${name}`
      );
    }
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/asset/getAssets?page=${pageNo}&size=${pageLimit}`
    );
  }

  // Admin

  getAllTenantUser(pageNo, pageLimit, type, name?): Observable<any> {
    if (name) {
      return this.http.get(
        `${this.BASE_URL}/${this.API_VERSION}/superAdmin/getTenantUsers?page=${pageNo}&size=${pageLimit}&type=${type}&name=${name}`
      );
    }
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/superAdmin/getTenantUsers?page=${pageNo}&size=${pageLimit}&type=${type}`
    );
  }

  getUserCount(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/superAdmin/getUsersCount`
    );
  }

  updateSuperAdmin(userData): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/superAdmin/updateTenantDetails`;
    const body = userData;
    return this.http.put(url, body);
  }
  // Dashboard

  getChipData(fromDate, toDate): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/dashboard/data?fromDate=${fromDate}&toDate=${toDate}`
    );
  }

  getChartData(month, year): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/dashboard/data/charts?month=${month}&year=${year}`
    );
  }

  getPieChartData(month, year): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/dashboard/data/charts-pie?month=${month}&year=${year}`
    );
  }

  getProspectGraphData(month, year): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/dashboard/prospectData?month=${month}&year=${year}`
    );
  }

  getCampaignGraphData(month, year): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/dashboard/campaignData?month=${month}&year=${year}`
    );
  }

  getAssetGraphData(month, year): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/dashboard/assetData?month=${month}&year=${year}`
    );
  }

  replyForwardMail(mailDetail, actionType): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/email/reply?name=${actionType}`;
    const body = mailDetail;
    return this.http.post(url, body);
  }

  getProspectListData(pageNo, pageLimit, status?, listId?): Observable<any> {
    if (status) {
      return this.http.get(
        `${this.BASE_URL}/${this.API_VERSION}/leads/listData?page=${pageNo}&size=${pageLimit}&status=${status}&listId=${listId}`
      );
    }
    if (listId) {
      return this.http.get(
        `${this.BASE_URL}/${this.API_VERSION}/leads/listData?page=${pageNo}&size=${pageLimit}&listId=${listId}`
      );
    }
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/leads/listData?page=${pageNo}&size=${pageLimit}&status=${status}&listId=${listId}`
    );
  }

  getListDataCount(listId): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/leads/listDataCount?listId=${listId}`
    );
  }

  getAccountLeads(pageNo, pageLimit, accountId): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/accounts/leads?accountId=${accountId}&page=${pageNo}&size=${pageLimit}`
    );
  }

  getSequence(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/sequence/fetch`
    );
  }

  createSequence(sequenceForm): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/sequence/create`;
    const body = sequenceForm;
    return this.http.post(url, body);
  }

  updateSequence(sequenceForm): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/sequence/update`;
    const body = sequenceForm;
    return this.http.put(url, body);
  }

  deleteSequence(sequenceId): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/sequence/delete`;
    const body = sequenceId;
    return this.http.put(url, body);
  }

  //Agent related
  getAgentAccountFunnel(pageNo, pageLimit, funnelName?, status?): Observable<any> {
    if (funnelName) {
      return this.http.get(
        `${this.BASE_URL}/${this.API_VERSION}/agent/campaign?page=${pageNo}&size=${pageLimit}&name=${funnelName}&status=${status}`
      );
    }
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/agent/campaign?page=${pageNo}&size=${pageLimit}&status=${status}`
    );
  }

  completePersona(personaId, status): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/campaign/personas/${personaId}/status`;
    const body = { status };
    return this.http.put(url, body);
  }

  getLeadsAndMessagesByPersonaId(personaId, pageNo, pageLimit) {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/agent/leads/${personaId}?page=${pageNo}&size=${pageLimit}`
    );
  }

  subscribe(plamDetails): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/subscription/subscribe`;
    const body = plamDetails;
    return this.http.post(url, body);
  }

  checkout(plamDetails): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/subscription/checkout`;
    const body = plamDetails;
    return this.http.post(url, body);
  }

  creditsCheckout(credits): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/subscription/checkout-credits`;
    const body = credits;
    return this.http.post(url, body);
  }

  changePlan(plamDetails): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/subscription/change`;
    const body = plamDetails;
    return this.http.post(url, body);
  }

  addCredits(credits): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/subscription/credits`;
    const body = credits;
    return this.http.post(url, body);
  }

  getProfile(): Observable<any> {
    return this.http.get(`${this.BASE_URL}/${this.API_VERSION}/user/profile`
    );
  }

  getSubscription(): Observable<any> {
    return this.http.get(`${this.BASE_URL}/${this.API_VERSION}/subscription/me`
    );
  }

  getSubscriptionPlans(): Observable<any> {
    return this.http.get(`${this.BASE_URL}/${this.API_VERSION}/subscription/plans`
    );
  }

  getSubscriptionAddOns(): Observable<any> {
    return this.http.get(`${this.BASE_URL}/${this.API_VERSION}/subscription/credits`
    );
  }

  getAllDomains(): Observable<any> {
    return this.http.get(`${this.BASE_URL}/${this.API_VERSION}/domain`
    );
  }

  getDomain(id): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/domain/${id}`
    );
  }

  createDomain(domain): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/domain`;
    const body = domain;
    return this.http.post(url, body);
  }

  createDomainUser(id, domain): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/domain/${id}/user`;
    const body = domain;
    return this.http.post(url, body);
  }

  getAllDomainUsers(id): Observable<any> {
    return this.http.get(`${this.BASE_URL}/${this.API_VERSION}/domain/${id}/user`
    );
  }

  createDomainKey(id, domain): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/domain/${id}/key`;
    const body = domain;
    return this.http.post(url, body);
  }

  verifyDomain(domain): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/domain`;
    const body = domain;
    return this.http.post(url, body);
  }

  getAccountFilters(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/accounts/filter`
    );
  }

  getAccountFilterOptions(key) {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/accounts/filter/options?key=${key}`
    );
  }

  getFormCampaigns() {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/form/campaigns`
    );
  }

  getFormsList(pageNo, pageLimit, type, accountFunnelId?): Observable<any> {
    if (accountFunnelId) {
      return this.http.get(
        `${this.BASE_URL}/${this.API_VERSION}/form?page=${pageNo}&size=${pageLimit}&type=${type}&accountFunnelId=${accountFunnelId}`
      );
    }
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/form?page=${pageNo}&size=${pageLimit}&type=${type}`
    );
  }

  getKeywords() {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/data/keywords`
    );
  }

  deleteKeyword(id): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/data/delete-keyword`;
    const body = id;
    return this.http.put(url, body);
  }

  deleteAccount(id): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/data/delete-account`;
    const body = id;
    return this.http.put(url, body);
  }

  getRecommendedAccounts(pageNo, pageLimit) {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/data/accounts?page=${pageNo}&size=${pageLimit}`
    );
  }

  createKeyword(keyword): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/data/create-keyword`;
    const body = {name: keyword};
    return this.http.post(url, body);
  }

  createRecommendedAccount(recommendedAccount): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/data/create-account`;
    const body = recommendedAccount;
    return this.http.post(url, body);
  }

  updateRecommendedAccount(recommendedAccount): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/data/update-account`;
    const body = recommendedAccount;
    return this.http.put(url, body);
  }

  getLeadJourney(leadId): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/leads/${leadId}/journey`
    );
  }

  getAgentLog(): Observable<any> {
    return this.http.get(
      `${this.BASE_URL}/${this.API_VERSION}/dashboard/agent-log`
    );
  }

  uploadRecommendedAccountList(fileDetail): Observable<any> {
    const url = `${this.BASE_URL}/${this.API_VERSION}/data/upload-accounts`;
    const body = fileDetail;
    return this.http.post(url, body);
  }

}
